import Search from '../components/search/search.vue'
import Persona from '../components/search/persona.vue'
import SubscriberLookup from '../components/lookup/subscriber-lookup.vue'
import mainStore from '../store/main.js'

export default [
  { path: '/', 
    name: 'default',
    component: Search,
  },
  { path: '/search', 
    name: 'search',
    component: Search,
  },
  { path: '/lookup', 
    name: 'lookup',
    component: SubscriberLookup,
  },
  { path: '/personas', 
    name: 'persona',
    component: Persona,
    beforeEnter: (to,from,next) => {
      if (!mainStore.state.user.privs.SP) {
        next({name:'default'});
      } else {
        next();
      }
    }
  },
]
